type PointOfCareSpecialtySource = {
  readonly id: string
  readonly word: string
  readonly synonym: string | null | undefined
  readonly specialtyTranslations: ReadonlyArray<{ readonly language: string; readonly name: string }>
  readonly careProviderSpecialty?: { readonly id: string; readonly name: string } | null
  readonly betterDocKey?: string | null
}

type PointOfCareSpecialtyOption = {
  id: string
  language: string
  word: string
  synonym: string | null
  specialty?: { id: string; name: string }
  betterDocKey?: string
}

const mapPointOfCareSpecialty = (
  pointOfCareSpecialty: PointOfCareSpecialtySource,
  language: string,
): PointOfCareSpecialtyOption => {
  const upperCaseLanguage = language.toUpperCase()
  const translation = pointOfCareSpecialty.specialtyTranslations.find(
    (specialtyTranslation) => specialtyTranslation.language === upperCaseLanguage,
  )

  return {
    id: pointOfCareSpecialty.id,
    language: upperCaseLanguage,
    word: translation?.name ?? pointOfCareSpecialty.word,
    synonym: pointOfCareSpecialty.synonym ?? null,
    specialty: pointOfCareSpecialty.careProviderSpecialty ?? undefined,
    betterDocKey: pointOfCareSpecialty.betterDocKey ?? undefined,
  }
}

export { mapPointOfCareSpecialty, type PointOfCareSpecialtySource }
